import React, { useContext, useState, useEffect } from "react";
import Head from "../Head/Head";
import Squares from "../Squares/Squares";
import Text from "../Text/Text";
import { pageFetchMainURL } from "../../constant";

import Elements from "../Elements/Elements";
import Twelvemm from "./Twelvemm";
import Twentymm from "./Twentymm";
import Thirtymm from "./Thirtymm";
import cx from "classnames";
import axios from "axios";
import { Tabs, Tab, Content } from "./tab";
import Modal from "../Modal";
import useModal from "../useModal";
import { SquareContext } from "../../SquareContext";
import "./StepNine.scss";

// import arrowred from "../../assets/plusred.svg";

function StepNine(props) {
  const { isShowing, toggle } = useModal();

  const {
    shapePortion,
    shape,
    cartItems,
    unitName,
    shapeUnits,
    shapeUnits2,
    shapeUnits3,
    shapeUnits4,
    shapeUnits5,
    shapeUnits6,
    shapeUnits7,
    shapeUnits8,
    shapeUnits9,
    shapeItems,
    activeColor,
    cart,
    isShowed,
    setIsShowed,
    isShowed2,
    setIsShowed2,
    isShowed3,
    setIsShowed3,
    totalPrice30a,
    totalPrice30b,
    totalPrice30c,
    totalPrice20a,
    totalPrice20b,
    totalPrice20c,
    totalPrice12a,
    totalPrice12b,
    totalPrice12c,
    portion,
    setResultTotal,
    result,
    setResSum,
    resultTotal,
    linearArea,
    setLinearAreaM,
    upstandPrice,
    slabArea,

    resSum,

    graniteType,
    slabQuartz,
    setSlabQuartz,
    slabGranite,
    setSlabGranite,
    slabCeramic,
    setSlabCeramic,
    stater,
    cuts,
    cuts2,
    jum,
    grooves,
    overSink,
    underSink,
    pop,
    tap,
    hob,
    splash,
    upst,
    led,
    setTotalPrice30a,
    setTotalPrice30b,
    setTotalPrice30c,
    edgePrice,
    recessed,
    setTotalPrice20a,
    setTotalPrice20b,
    setTotalPrice20c,
    setTotalPrice12a,
    setTotalPrice12b,
    setTotalPrice12c,
    findThick,
    cornerPrice,
    overPrice,
    underPrice,
    drainPrice,
    recessedPrice,
    tapPrice,
    hobPrice,
    popPrice,
    sidePrice,
    winPrice,
    jumNor,
    norArea,
    jumArea,
    windowArea,
    splashArea,
    splashPrice,
    linearAreaM,
    groovesPrice,
    upstandArea,
    countyId,
    surnameForm,
    addressForm,
    additionalForm,
    edge,
    whichStone,
    whichStone2,
    whichStone3,
    nameForm,
    teleForm,
    mailForm,
    country,
    day,
    month,
    year,
    inVal,
    inVal10,
    inVal2,
    inVal3,
    inVal4,
    inVal5,
    inVal6,
    inVal7,
    inVal8,
    inVal9,
    setLinearArea,
    stepDesc,
    unity2,
    unity3,
    checked,
    checked2,
    checked3,
    checked4,
    checked5,
    checked6,
    checked7,
    checked8,
    checked9,
    mediumArea,
  } = useContext(SquareContext);

  const [active, setActive] = useState(0);
  const [active2, setActive2] = useState(0);
  const [active3, setActive3] = useState(0);

  useEffect(() => {
    if (cart.length === 0) {
      props.jump(1);
    }
  }, [cart]);

  useEffect(() => {
    if (unity2 === 0 && cart[1] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity2]);

  useEffect(() => {
    if (unity3 === 0 && cart[2] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity3]);

  const closeTabs = () => {
    setIsShowed(false);
    setIsShowed2(false);
    setIsShowed3(false);
  };

  const switchActive = () => {
    if (shapeUnits.length === 0 && shapeUnits2.length !== 0) {
      setActive(1);
    } else if (shapeUnits.length !== 0) {
      setActive(0);
    } else if (shapeUnits.length === 0 && shapeUnits2.length === 0) {
      setActive(2);
    }
  };
  const switchActive2 = () => {
    if (shapeUnits3.length === 0 && shapeUnits4.length !== 0) {
      setActive2(1);
    } else if (shapeUnits3.length !== 0) {
      setActive2(0);
    } else if (shapeUnits3.length === 0 && shapeUnits4.length === 0) {
      setActive2(2);
    }
  };
  const switchActive3 = () => {
    if (shapeUnits5.length === 0 && shapeUnits6.length !== 0) {
      setActive3(1);
    } else if (shapeUnits5.length !== 0) {
      setActive3(0);
    } else if (shapeUnits5.length === 0 && shapeUnits6.length === 0) {
      setActive3(2);
    }
  };
  const handleTab = (e) => {
    const index = parseInt(e.target.id);
    if (index !== active) {
      setActive(index);
    }
  };
  const handleTab2 = (e) => {
    const index = parseInt(e.target.id);
    if (index !== active2) {
      setActive2(index);
    }
  };

  const handleTab3 = (e) => {
    const index = parseInt(e.target.id);
    if (index !== active3) {
      setActive3(index);
    }
  };

  function handleClick(a, b) {
    if (!a) {
      b(true);
    } else {
      b(false);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // useEffect(() => {

  // setLinearArea(
  //   (inVal === "" || inVal2 === "" ?  0 : (parseFloat(inVal) + parseFloat(inVal2)) * 2) +
  //   (inVal3 === "" || inVal4 === "" ?  0 : (parseFloat(inVal3) * parseFloat(inVal4)) *2) +
  //   (inVal5 === "" || inVal6 === "" ?  0 : (parseFloat(inVal5) * parseFloat(inVal6)) *2) +
  //   (inVal7 === "" || inVal8 === "" ?  0 : (parseFloat(inVal7) * parseFloat(inVal8)) *2) +
  //   (inVal9 === "" || inVal10 === "" ?  0 : (parseFloat(inVal9) * parseFloat(inVal10)) *2)
  //   )

  // },[inVal, inVal10, inVal2, inVal3, inVal4, inVal5, inVal6, inVal7, inVal8, inVal9, setLinearArea])

  useEffect(() => {
    // first stone
    const totalCeramic =
      (resultTotal +
        parseInt(cuts) * norArea +
        parseInt(cuts2) * windowArea +
        (splash === "YES" ? parseFloat(splashArea) : 0) +
        (upst === "YES" ? upstandArea : 0)) /
      parseFloat(slabArea[0]);
    setSlabCeramic(Math.ceil(totalCeramic));
  }, [
    cuts,
    cuts2,
    graniteType,
    upstandArea,
    resultTotal,
    setSlabCeramic,
    slabArea,
    splash,
    splashArea,
    upst,
    windowArea,
    norArea,
  ]);

  useEffect(() => {
    //  second stone
    const totalQuartz =
      (resultTotal +
        parseInt(cuts) * norArea +
        parseInt(cuts2) * windowArea +
        (splash === "YES" ? parseFloat(splashArea) : 0) +
        (upst === "YES" ? upstandArea : 0)) /
      parseFloat(slabArea[1]);

    setSlabQuartz(Math.ceil(totalQuartz));
  }, [
    cuts,
    cuts2,
    graniteType,
    upstandArea,
    resultTotal,
    setSlabQuartz,
    slabArea,
    splash,
    splashArea,
    upst,
    windowArea,
    norArea,
  ]);

  useEffect(() => {
    // third
    const totalGranite =
      (resultTotal +
        parseInt(cuts) * norArea +
        parseInt(cuts2) * windowArea +
        (splash === "YES" ? parseFloat(splashArea) : 0) +
        (upst === "YES" ? upstandArea : 0)) /
      parseFloat(slabArea[2]);
    setSlabGranite(Math.ceil(totalGranite));
  }, [
    cuts,
    cuts2,
    graniteType,
    upstandArea,
    resultTotal,
    setSlabGranite,
    slabArea,
    splash,
    splashArea,
    upst,
    windowArea,
    norArea,
  ]);

  // ---------------------------------------------------------------------------------------------------------------------

  useEffect(() => {
    if (portion.find((obj) => obj.id === 1)) {
      setResultTotal(Math.round((resultTotal / 1000000) * 100) / 100);
    } else if (portion.find((obj) => obj.id === 2)) {
      setResultTotal(Math.round((resultTotal / 10000) * 100) / 100);
    } else if (portion.find((obj) => obj.id === 3)) {
      setResultTotal(Math.round(resultTotal * 100) / 100);
    } else if (portion.find((obj) => obj.id === 4)) {
      setResultTotal(Math.round((resultTotal / 1550) * 100) / 100);
    }
  }, []);

  useEffect(() => {
    if (portion.find((obj) => obj.id === 1)) {
      setResSum(Math.round((result / 1000) * 100) / 100);
    } else if (portion.find((obj) => obj.id === 2)) {
      setResSum(Math.round((result / 100) * 100) / 100);
    } else if (portion.find((obj) => obj.id === 3)) {
      setResSum(Math.round(result * 100) / 100);
    } else if (portion.find((obj) => obj.id === 4)) {
      setResSum(Math.round((result / 39.4) * 100) / 100);
    }
  }, []);

  useEffect(() => {
    if (portion.find((obj) => obj.id === 1)) {
      setLinearAreaM(Math.round((linearArea / 1000) * 100) / 100);
    } else if (portion.find((obj) => obj.id === 2)) {
      setLinearAreaM(Math.round((linearArea / 100) * 100) / 100);
    } else if (portion.find((obj) => obj.id === 3)) {
      setLinearAreaM(Math.round(linearArea * 100) / 100);
    } else if (portion.find((obj) => obj.id === 4)) {
      setLinearAreaM(Math.round((linearArea / 39.4) * 100) / 100);
    }
  }, []);

  //========================================================================================================

  // function areaSide() {
  //   switch (jum) {
  //     case "Normal":
  //       return norArea;
  //     case "Medium":
  //       return mediumArea;
  //     case "Jumbo":
  //       return jumArea;
  //     default:
  //       return 0;
  //   }
  // }

  // useEffect(() => {
  //   if (cart[0] !== undefined) {
  //   if (cart[0].category === "Granite") {
  //     setWhichStone(slabGranite);
  //   } else if (cart[0].category === "Quartz") {
  //     setWhichStone(slabQuartz);
  //   } else if (cart[0].category === "Ceramic") {
  //     setWhichStone(slabCeramic);
  //   }
  // }
  // }, [cart, whichStone, slabGranite, slabQuartz, slabCeramic]);

  // useEffect(() => {
  //   if (cart[1] !== undefined) {
  //     if (cart[1].category === "Granite") {
  //       setWhichStone2(slabGranite);
  //     } else if (cart[1].category === "Quartz") {
  //       setWhichStone2(slabQuartz);
  //     } else if (cart[1].category === "Ceramic") {
  //       setWhichStone2(slabCeramic);
  //     } else {
  //       setWhichStone2(0);
  //     }
  //   }
  // }, [cart, whichStone2, slabGranite, slabQuartz, slabCeramic]);

  // useEffect(() => {
  //   if (cart[2] !== undefined) {
  //     if (cart[2].category === "Granite") {
  //       setWhichStone3(slabGranite);
  //     } else if (cart[2].category === "Quartz") {
  //       setWhichStone3(slabQuartz);
  //     } else if (cart[2].category === "Ceramic") {
  //       setWhichStone3(slabCeramic);
  //     } else {
  //       setWhichStone3(0);
  //     }
  //   }
  // }, [cart, whichStone3, slabGranite, slabQuartz, slabCeramic]);

  // ---------------------------------------twelve 12----------------------------------------------------------

  useEffect(() => {}, []);

  useEffect(() => {
    if (findThick[0] !== undefined) {
      setTotalPrice12a(
        Math.round(
          (slabCeramic * parseFloat(findThick[0]["12mm"]) +
            Math.round(resSum * edgePrice * 100) / 100 +
            parseFloat(cornerPrice) * stater +
            (overSink === "YES" ? parseFloat(overPrice) : 0) +
            (underSink === "YES" ? parseFloat(underPrice) : 0) +
            (grooves === "YES" ? parseFloat(drainPrice) : 0) +
            parseFloat(tapPrice) * tap +
            parseFloat(sidePrice) * cuts +
            parseFloat(winPrice) * cuts2 +
            // (jum !== "" &&
            //   (jum === "Normal"
            //     ? parseFloat(jumNor[0]["price"])
            //     : parseFloat(jumNor[1]["price"]))) +
            (hob === "YES" ? parseFloat(hobPrice) : 0) +
            (pop === "YES" ? parseFloat(popPrice) : 0) +
            (splash === "YES" ? parseFloat(splashPrice) : 0) +
            (upst === "YES"
              ? (linearAreaM - resSum) * parseFloat(upstandPrice)
              : 0) +
            (led === "YES" ? resSum * parseFloat(groovesPrice) : 0) +
            (recessed === "YES" ? parseFloat(recessedPrice) : 0) +
            parseFloat(countyId.price)) *
            100
        ) / 100
        // + (recessed === "YES" ? 40 : 0)
      );
    }
    if (findThick[1] !== undefined) {
      setTotalPrice12b(
        Math.round(
          (slabQuartz * parseFloat(findThick[1]["12mm"]) +
            Math.round(resSum * edgePrice * 100) / 100 +
            parseFloat(cornerPrice) * stater +
            (overSink === "YES" ? parseFloat(overPrice) : 0) +
            (underSink === "YES" ? parseFloat(underPrice) : 0) +
            (grooves === "YES" ? parseFloat(drainPrice) : 0) +
            parseFloat(tapPrice) * tap +
            parseFloat(sidePrice) * cuts +
            parseFloat(winPrice) * cuts2 +
            // (jum !== "" &&
            //   (jum === "Normal"
            //     ? parseFloat(jumNor[0]["price"])
            //     : parseFloat(jumNor[1]["price"]))) +
            (hob === "YES" ? parseFloat(hobPrice) : 0) +
            (pop === "YES" ? parseFloat(popPrice) : 0) +
            (splash === "YES" ? parseFloat(splashPrice) : 0) +
            (upst === "YES"
              ? (linearAreaM - resSum) * parseFloat(upstandPrice)
              : 0) +
            (led === "YES" ? resSum * parseFloat(groovesPrice) : 0) +
            (recessed === "YES" ? parseFloat(recessedPrice) : 0) +
            parseFloat(countyId.price)) *
            100
        ) / 100
        // + (recessed === "YES" ? 40 : 0)
      );
    }
    if (findThick[2] !== undefined) {
      setTotalPrice12c(
        Math.round(
          (slabGranite * parseFloat(findThick[2]["12mm"]) +
            Math.round(resSum * edgePrice * 100) / 100 +
            parseFloat(cornerPrice) * stater +
            (overSink === "YES" ? parseFloat(overPrice) : 0) +
            (underSink === "YES" ? parseFloat(underPrice) : 0) +
            (grooves === "YES" ? parseFloat(drainPrice) : 0) +
            parseFloat(tapPrice) * tap +
            parseFloat(sidePrice) * cuts +
            parseFloat(winPrice) * cuts2 +
            // (jum !== "" &&
            //   (jum === "Normal"
            //     ? parseFloat(jumNor[0]["price"])
            //     : parseFloat(jumNor[1]["price"]))) +
            (hob === "YES" ? parseFloat(hobPrice) : 0) +
            (pop === "YES" ? parseFloat(popPrice) : 0) +
            (splash === "YES" ? parseFloat(splashPrice) : 0) +
            (upst === "YES"
              ? (linearAreaM - resSum) * parseFloat(upstandPrice)
              : 0) +
            (led === "YES" ? resSum * parseFloat(groovesPrice) : 0) +
            (recessed === "YES" ? parseFloat(recessedPrice) : 0) +
            parseFloat(countyId.price)) *
            100
        ) / 100
        // + (recessed === "YES" ? 40 : 0)
      );
    }
  }, [
    cuts,
    cuts2,
    drainPrice,
    edgePrice,
    findThick,
    grooves,
    hob,
    led,
    overPrice,
    overSink,
    pop,
    recessed,
    recessedPrice,
    resSum,
    setTotalPrice12a,
    setTotalPrice12b,
    setTotalPrice12c,
    setTotalPrice20a,
    setTotalPrice20b,
    setTotalPrice20c,
    cornerPrice,
    splash,
    stater,
    tap,
    underPrice,
    underSink,
    upst,
    whichStone,
    whichStone2,
    whichStone3,
    tapPrice,
    hobPrice,
    popPrice,
    sidePrice,
    winPrice,
    jum,
    jumNor,
    splashPrice,
    linearAreaM,
    upstandPrice,
    groovesPrice,
    slabCeramic,
    countyId.price,
    slabQuartz,
    slabGranite,
  ]);

  // ---------------------------------------twenty----20------------------------------------------------------

  // useEffect(() => {

  //   const timer = setTimeout(() => {
  //     console.log((slabCeramic * parseFloat(findThick[0]["20mm"])), "slab price");
  // console.log((Math.round((resSum * edgePrice) * 100) / 100) , "edge");
  // console.log(parseFloat(cornerPrice) * stater, "corner");
  // console.log((overSink === "YES" ? parseFloat(overPrice) : 0), "overmounted");
  // console.log(underSink === "YES" ? parseFloat(underPrice) : 0, "undermounted");
  // console.log(grooves === "YES" ? parseFloat(drainPrice) : 0, "drain grooves");
  // console.log(parseFloat(tapPrice) * tap, "tabs");
  // console.log(parseFloat(sidePrice) * cuts, "side panels");
  // console.log(parseFloat(winPrice) * cuts2, "window sills");
  // // console.log((jum !== "" &&
  // // (jum === "Normal"
  // //   ? parseFloat(jumNor[0]["price"])
  // //   : parseFloat(jumNor[1]["price"]))), "jumboNormal sidePanels");
  //   console.log(hob === "YES" ? parseFloat(hobPrice) : 0, "hob cut out")
  //   console.log(pop === "YES" ? parseFloat(popPrice) : 0, "pop out socket")
  //   console.log(splash === "YES" ? parseFloat(splashPrice) : 0, "splashback")
  //   console.log(upst === "YES"
  //   ? (linearAreaM - resSum) * parseFloat(upstandPrice)
  //   : 0, "upstands")
  //   console.log(led === "YES" ? resSum * parseFloat(groovesPrice) : 0, "led grooves");
  //   console.log(recessed === "YES" ? parseFloat(recessedPrice) : 0, "recessed");
  //   console.log(parseFloat(countyId.price), "county")
  //   console.log(totalPrice20a, "total")

  //   }, 1000);
  //   return () => clearTimeout(timer);

  // },[cornerPrice, countyId.price, cuts, cuts2, drainPrice, edgePrice, findThick, grooves, groovesPrice, hob, hobPrice, jum, jumNor, led, linearAreaM, overPrice, overSink, pop, popPrice, recessed, recessedPrice, resSum, sidePrice, slabCeramic, splash, splashPrice, stater, tap, tapPrice, totalPrice20a, underPrice, underSink, upst, upstandPrice, winPrice])

  useEffect(() => {
    if (findThick[0] !== undefined) {
      setTotalPrice20a(
        Math.round(
          (slabCeramic * parseFloat(findThick[0]["20mm"]) +
            Math.round(resSum * edgePrice * 100) / 100 +
            parseFloat(cornerPrice) * stater +
            (overSink === "YES" ? parseFloat(overPrice) : 0) +
            (underSink === "YES" ? parseFloat(underPrice) : 0) +
            (grooves === "YES" ? parseFloat(drainPrice) : 0) +
            parseFloat(tapPrice) * tap +
            parseFloat(sidePrice) * cuts +
            parseFloat(winPrice) * cuts2 +
            // (jum !== "" &&
            //   (jum === "Normal"
            //     ? parseFloat(jumNor[0]["price"])
            //     : parseFloat(jumNor[1]["price"]))) +
            (hob === "YES" ? parseFloat(hobPrice) : 0) +
            (pop === "YES" ? parseFloat(popPrice) : 0) +
            (splash === "YES" ? parseFloat(splashPrice) : 0) +
            (upst === "YES"
              ? (linearAreaM - resSum) * parseFloat(upstandPrice)
              : 0) +
            (led === "YES" ? resSum * parseFloat(groovesPrice) : 0) +
            (recessed === "YES" ? parseFloat(recessedPrice) : 0) +
            parseFloat(countyId.price)) *
            100
        ) / 100
        // + (recessed === "YES" ? 40 : 0)
      );
    }

    if (findThick[1] !== undefined) {
      setTotalPrice20b(
        Math.round(
          (slabQuartz * parseFloat(findThick[1]["20mm"]) +
            Math.round(resSum * edgePrice * 100) / 100 +
            parseFloat(cornerPrice) * stater +
            (overSink === "YES" ? parseFloat(overPrice) : 0) +
            (underSink === "YES" ? parseFloat(underPrice) : 0) +
            (grooves === "YES" ? parseFloat(drainPrice) : 0) +
            parseFloat(tapPrice) * tap +
            parseFloat(sidePrice) * cuts +
            parseFloat(winPrice) * cuts2 +
            // (jum !== "" &&
            //   (jum === "Normal"
            //     ? parseFloat(jumNor[0]["price"])
            //     : parseFloat(jumNor[1]["price"]))) +
            (hob === "YES" ? parseFloat(hobPrice) : 0) +
            (pop === "YES" ? parseFloat(popPrice) : 0) +
            (splash === "YES" ? parseFloat(splashPrice) : 0) +
            (upst === "YES"
              ? (linearAreaM - resSum) * parseFloat(upstandPrice)
              : 0) +
            (led === "YES" ? resSum * parseFloat(groovesPrice) : 0) +
            (recessed === "YES" ? parseFloat(recessedPrice) : 0) +
            parseFloat(countyId.price)) *
            100
        ) / 100
        // + (recessed === "YES" ? 40 : 0)
      );
    }
    if (findThick[2] !== undefined) {
      setTotalPrice20c(
        Math.round(
          (slabGranite * parseFloat(findThick[2]["20mm"]) +
            Math.round(resSum * edgePrice * 100) / 100 +
            parseFloat(cornerPrice) * stater +
            (overSink === "YES" ? parseFloat(overPrice) : 0) +
            (underSink === "YES" ? parseFloat(underPrice) : 0) +
            (grooves === "YES" ? parseFloat(drainPrice) : 0) +
            parseFloat(tapPrice) * tap +
            parseFloat(sidePrice) * cuts +
            parseFloat(winPrice) * cuts2 +
            // (jum !== "" &&
            //   (jum === "Normal"
            //     ? parseFloat(jumNor[0]["price"])
            //     : parseFloat(jumNor[1]["price"]))) +
            (hob === "YES" ? parseFloat(hobPrice) : 0) +
            (pop === "YES" ? parseFloat(popPrice) : 0) +
            (splash === "YES" ? parseFloat(splashPrice) : 0) +
            (upst === "YES"
              ? (linearAreaM - resSum) * parseFloat(upstandPrice)
              : 0) +
            (led === "YES" ? resSum * parseFloat(groovesPrice) : 0) +
            (recessed === "YES" ? parseFloat(recessedPrice) : 0) +
            parseFloat(countyId.price)) *
            100
        ) / 100
        // + (recessed === "YES" ? 40 : 0)
      );
    }
  }, [
    cuts,
    cuts2,
    drainPrice,
    edgePrice,
    findThick,
    grooves,
    hob,
    led,
    overPrice,
    overSink,
    pop,
    recessed,
    recessedPrice,
    resSum,
    setTotalPrice20a,
    setTotalPrice20b,
    setTotalPrice20c,
    cornerPrice,
    splash,
    stater,
    tap,
    underPrice,
    underSink,
    upst,
    whichStone,
    whichStone2,
    whichStone3,
    tapPrice,
    hobPrice,
    popPrice,
    sidePrice,
    winPrice,
    jum,
    jumNor,
    splashPrice,
    linearAreaM,
    upstandPrice,
    groovesPrice,
    slabCeramic,
    countyId.price,
    slabQuartz,
    slabGranite,
  ]);

  // ---------------------------------------thirty 30----------------------------------------------------------
  useEffect(() => {
    if (findThick[0] !== undefined) {
      setTotalPrice30a(
        Math.round(
          (slabCeramic * parseFloat(findThick[0]["30mm"]) +
            Math.round(resSum * edgePrice * 100) / 100 +
            parseFloat(cornerPrice) * stater +
            (overSink === "YES" ? parseFloat(overPrice) : 0) +
            (underSink === "YES" ? parseFloat(underPrice) : 0) +
            (grooves === "YES" ? parseFloat(drainPrice) : 0) +
            parseFloat(tapPrice) * tap +
            parseFloat(sidePrice) * cuts +
            parseFloat(winPrice) * cuts2 +
            // (jum !== "" &&
            //   (jum === "Normal"
            //     ? parseFloat(jumNor[0]["price"])
            //     : parseFloat(jumNor[1]["price"]))) +
            (hob === "YES" ? parseFloat(hobPrice) : 0) +
            (pop === "YES" ? parseFloat(popPrice) : 0) +
            (splash === "YES" ? parseFloat(splashPrice) : 0) +
            (upst === "YES"
              ? (linearAreaM - resSum) * parseFloat(upstandPrice)
              : 0) +
            (led === "YES" ? resSum * parseFloat(groovesPrice) : 0) +
            (recessed === "YES" ? parseFloat(recessedPrice) : 0) +
            parseFloat(countyId.price)) *
            100
        ) / 100
        // + (recessed === "YES" ? 40 : 0)
      );
    }
    if (findThick[1] !== undefined) {
      setTotalPrice30b(
        Math.round(
          (slabQuartz * parseFloat(findThick[1]["30mm"]) +
            Math.round(resSum * edgePrice * 100) / 100 +
            parseFloat(cornerPrice) * stater +
            (overSink === "YES" ? parseFloat(overPrice) : 0) +
            (underSink === "YES" ? parseFloat(underPrice) : 0) +
            (grooves === "YES" ? parseFloat(drainPrice) : 0) +
            parseFloat(tapPrice) * tap +
            parseFloat(sidePrice) * cuts +
            parseFloat(winPrice) * cuts2 +
            // (jum !== "" &&
            //   (jum === "Normal"
            //     ? parseFloat(jumNor[0]["price"])
            //     : parseFloat(jumNor[1]["price"]))) +
            (hob === "YES" ? parseFloat(hobPrice) : 0) +
            (pop === "YES" ? parseFloat(popPrice) : 0) +
            (splash === "YES" ? parseFloat(splashPrice) : 0) +
            (upst === "YES"
              ? (linearAreaM - resSum) * parseFloat(upstandPrice)
              : 0) +
            (led === "YES" ? resSum * parseFloat(groovesPrice) : 0) +
            (recessed === "YES" ? parseFloat(recessedPrice) : 0) +
            parseFloat(countyId.price)) *
            100
        ) / 100
        // + (recessed === "YES" ? 40 : 0)
      );
    }
    if (findThick[2] !== undefined) {
      setTotalPrice30c(
        Math.round(
          (slabGranite * parseFloat(findThick[2]["30mm"]) +
            Math.round(resSum * edgePrice * 100) / 100 +
            parseFloat(cornerPrice) * stater +
            (overSink === "YES" ? parseFloat(overPrice) : 0) +
            (underSink === "YES" ? parseFloat(underPrice) : 0) +
            (grooves === "YES" ? parseFloat(drainPrice) : 0) +
            parseFloat(tapPrice) * tap +
            parseFloat(sidePrice) * cuts +
            parseFloat(winPrice) * cuts2 +
            // (jum !== "" &&
            //   (jum === "Normal"
            //     ? parseFloat(jumNor[0]["price"])
            //     : parseFloat(jumNor[1]["price"]))) +
            (hob === "YES" ? parseFloat(hobPrice) : 0) +
            (pop === "YES" ? parseFloat(popPrice) : 0) +
            (splash === "YES" ? parseFloat(splashPrice) : 0) +
            (upst === "YES"
              ? (linearAreaM - resSum) * parseFloat(upstandPrice)
              : 0) +
            (led === "YES" ? resSum * parseFloat(groovesPrice) : 0) +
            (recessed === "YES" ? parseFloat(recessedPrice) : 0) +
            parseFloat(countyId.price)) *
            100
        ) / 100
        // + (recessed === "YES" ? 40 : 0)
      );
    }
  }, [
    cuts,
    cuts2,
    drainPrice,
    edgePrice,
    findThick,
    grooves,
    hob,
    led,
    overPrice,
    overSink,
    pop,
    recessed,
    recessedPrice,
    resSum,
    setTotalPrice30a,
    setTotalPrice30b,
    setTotalPrice30c,
    cornerPrice,
    splash,
    stater,
    tap,
    underPrice,
    underSink,
    upst,
    whichStone,
    whichStone2,
    whichStone3,
    tapPrice,
    hobPrice,
    popPrice,
    sidePrice,
    winPrice,
    jum,
    jumNor,
    splashPrice,
    linearAreaM,
    upstandPrice,
    groovesPrice,
    slabCeramic,
    countyId.price,
    slabQuartz,
    slabGranite,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      document.getElementById("send").click();
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  // ----------------------------------------------------------a-x-i-o-s--------------------------------------------------

  const data = {
    name: nameForm,
    surname: surnameForm,
    telephone: teleForm,
    email: mailForm,
    county: country,
    address: addressForm,
    date: `${day} ${month} ${year}`,
    additional: additionalForm,
    kitchen_shape: shape[0].name,
    ...(portion[0] !== undefined && { unit: portion[0].name }),
    area: resultTotal + " m squared",
    upstands_length: linearAreaM - resSum + "m",
    areaFactors: {
      ...(inVal.length !== 0 && { area1width: inVal }),
      ...(inVal2.length !== 0 && { area1length: inVal2 }),
      ...(inVal3.length !== 0 && { area2width: inVal3 }),
      ...(inVal4.length !== 0 && { area2length: inVal4 }),
      ...(inVal5.length !== 0 && { area3width: inVal5 }),
      ...(inVal6.length !== 0 && { area3length: inVal6 }),
      ...(inVal7.length !== 0 && { area4width: inVal7 }),
      ...(inVal8.length !== 0 && { area4length: inVal8 }),
      ...(inVal9.length !== 0 && { area5width: inVal9 }),
      ...(inVal10.length !== 0 && { area5length: inVal10 }),
    },

    length: resSum + " m",
    edge: edge[0].name,
    corners: stater,
    overmounted: overSink,
    undermounted: underSink,
    grooves: grooves,
    tap: tap,
    sidepanels: cuts + "  " + jum,
    windowsills: cuts2,
    hob: hob,
    pop: pop,
    splashback: splash,
    upstands: upst,
    led: led,
    reccesedarea: recessed,
    stones: [
      cart[0] !== undefined
        ? {
            id: 1,
            name: cart[0].title,
            brand: cart[0].brand,

            ...(slabArea[0] !== undefined && { slab_area: slabArea[0] }),

            thicknesses: {
              ...(shapeUnits.length !== 0 && { thick1: "12mm" }),
              ...(shapeUnits2.length !== 0 && { thick2: "20mm" }),
              ...(shapeUnits7.length !== 0 && { thick3: "30mm" }),
            },
            stone_price: {
              ...(shapeUnits.length !== 0 && { "12mm": findThick[0]["12mm"] }),
              ...(shapeUnits2.length !== 0 && { "20mm": findThick[0]["20mm"] }),
              ...(shapeUnits7.length !== 0 && { "30mm": findThick[0]["30mm"] }),
            },
            thicknessessub: {
              ...(shapeUnits.length !== 0 && { twelvesub: totalPrice12a }),
              ...(shapeUnits2.length !== 0 && { twentysub: totalPrice20a }),
              ...(shapeUnits7.length !== 0 && { thirtysub: totalPrice30a }),
            },
            thicknessesstotal: {
              ...(shapeUnits.length !== 0 && {
                twelvetotal: Math.round(totalPrice12a * 1.2 * 100) / 100,
              }),
              ...(shapeUnits2.length !== 0 && {
                twentytotal: Math.round(totalPrice20a * 1.2 * 100) / 100,
              }),
              ...(shapeUnits7.length !== 0 && {
                thirtytotal: Math.round(totalPrice30a * 1.2 * 100) / 100,
              }),
            },
            vat: {
              ...(shapeUnits.length !== 0 && {
                twelvevat: Math.round(totalPrice12a * 0.2 * 100) / 100,
              }),
              ...(shapeUnits2.length !== 0 && {
                twentyvat: Math.round(totalPrice20a * 0.2 * 100) / 100,
              }),
              ...(shapeUnits7.length !== 0 && {
                thirtyvat: Math.round(totalPrice30a * 0.2 * 100) / 100,
              }),
            },
          }
        : { name: "1 stone not selected" },
      cart[1] !== undefined && {
        id: 2,
        name: cart[1].title,
        brand: cart[1].brand,
        ...(slabArea[1] !== undefined && { slab_area: slabArea[1] }),

        thicknesses: {
          ...(shapeUnits3.length !== 0 && { thick1: "12mm" }),
          ...(shapeUnits4.length !== 0 && { thick2: "20mm" }),
          ...(shapeUnits8.length !== 0 && { thick3: "30mm" }),
        },
        stone_price: {
          ...(shapeUnits3.length !== 0 && { "12mm": findThick[1]["12mm"] }),
          ...(shapeUnits4.length !== 0 && { "20mm": findThick[1]["20mm"] }),
          ...(shapeUnits8.length !== 0 && { "30mm": findThick[1]["30mm"] }),
        },
        thicknessessub: {
          ...(shapeUnits3.length !== 0 && { twelvesub: totalPrice12b }),
          ...(shapeUnits4.length !== 0 && { twentysub: totalPrice20b }),
          ...(shapeUnits8.length !== 0 && { thirtysub: totalPrice30b }),
        },
        thicknessesstotal: {
          ...(shapeUnits3.length !== 0 && {
            twelvetotal: Math.round(totalPrice12b * 1.2 * 100) / 100,
          }),
          ...(shapeUnits4.length !== 0 && {
            twentytotal: Math.round(totalPrice20b * 1.2 * 100) / 100,
          }),
          ...(shapeUnits8.length !== 0 && {
            thirtytotal: Math.round(totalPrice30b * 1.2 * 100) / 100,
          }),
        },
        vat: {
          ...(shapeUnits3.length !== 0 && {
            twelvevat: Math.round(totalPrice12b * 0.2 * 100) / 100,
          }),
          ...(shapeUnits4.length !== 0 && {
            twentyvat: Math.round(totalPrice20b * 0.2 * 100) / 100,
          }),
          ...(shapeUnits8.length !== 0 && {
            thirtyvat: Math.round(totalPrice30b * 0.2 * 100) / 100,
          }),
        },
      },
      cart[2] !== undefined
        ? {
            id: 3,
            name: cart[2].title,
            brand: cart[2].brand,
            ...(slabArea[2] !== undefined && { slab_area: slabArea[2] }),

            thicknesses: {
              ...(shapeUnits5.length !== 0 && { thick1: "12mm" }),
              ...(shapeUnits6.length !== 0 && { thick2: "20mm" }),
              ...(shapeUnits9.length !== 0 && { thick3: "30mm" }),
            },
            stone_price: {
              ...(shapeUnits5.length !== 0 && { "12mm": findThick[2]["12mm"] }),
              ...(shapeUnits6.length !== 0 && { "20mm": findThick[2]["20mm"] }),
              ...(shapeUnits9.length !== 0 && { "30mm": findThick[2]["30mm"] }),
            },
            thicknessessub: {
              ...(shapeUnits5.length !== 0 && { twelvesub: totalPrice12c }),
              ...(shapeUnits6.length !== 0 && { twentysub: totalPrice20c }),
              ...(shapeUnits9.length !== 0 && { thirtysub: totalPrice30c }),
            },
            thicknessesstotal: {
              ...(shapeUnits5.length !== 0 && {
                twelvetotal: Math.round(totalPrice12c * 1.2 * 100) / 100,
              }),
              ...(shapeUnits6.length !== 0 && {
                twentytotal: Math.round(totalPrice20c * 1.2 * 100) / 100,
              }),
              ...(shapeUnits9.length !== 0 && {
                thirtytotal: Math.round(totalPrice30c * 1.2 * 100) / 100,
              }),
            },
            vat: {
              ...(shapeUnits5.length !== 0 && {
                twelvevat: Math.round(totalPrice12c * 0.2 * 100) / 100,
              }),
              ...(shapeUnits6.length !== 0 && {
                twentyvat: Math.round(totalPrice20c * 0.2 * 100) / 100,
              }),
              ...(shapeUnits9.length !== 0 && {
                thirtyvat: Math.round(totalPrice30c * 0.2 * 100) / 100,
              }),
            },
          }
        : null,
    ].filter(Boolean),
  };

  //-----------------------------------AXIOS-------------------------------------------------------------

  const options = {
    headers: {
      //  "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  // useEffect(() => {

  //     document.getElementById("send").click();

  // },[])

  // console.log(totalPrice12a)
  // console.log(totalPrice20a)
  // console.log(totalPrice30a)

  // console.log(shapeUnits)
  //   console.log(shapeUnits2)
  //   console.log(shapeUnits7)

  const axiosSend = () => {
    axios
      .post(`${pageFetchMainURL}/sendonlinequote/`, data)
      .then((res) => {
        //  console.log(res);
      })
      .catch((err) => {
        // console.log("ERROR: ====", err);
      });
  };

  // useEffect(() => {
  //   axiosSend();
  // }, []);

  //==================================================================================================
  // console.log(cart[0])
  // console.log(cart[1])

  // console.log(cart[0].kitchen3d_url)

  useEffect(() => {
    if (cartItems[0] === undefined) {
      setIsShowed(false);
    } else if (cartItems[1] === undefined) {
      setIsShowed2(false);
    } else if (cartItems[2] === undefined) {
      setIsShowed3(false);
    }
  }, [cartItems, setIsShowed, setIsShowed2, setIsShowed3]);

  return (
    <>
      <div className="stepEight">
        {stepDesc[8] && (
          <div>
            <div className="head">
              <p className="head-red">STEP 9</p>
              <p className="head-line">I</p>
              <p dangerouslySetInnerHTML={{ __html: stepDesc[8].title }}></p>
            </div>
          </div>
        )}

        <div className="stone">
          <Squares
            first={() => {
              if (props.order === 9) {
                props.jump(1);
              } else {
                props.jump(9);
              }
            }}
            second={() => {
              if (props.order === 9) {
                props.jump(1);
              } else {
                props.jump(9);
              }
            }}
            third={() => {
              if (props.order === 9) {
                props.jump(1);
              } else {
                props.jump(9);
              }
            }}
          />
          {stepDesc[8] !== undefined && (
            <div
              className="text-middle2"
              dangerouslySetInnerHTML={{ __html: stepDesc[8].description }}
            >
              {/* <Text desc={stepDesc[8] !== undefined && stepDesc[8].description} /> */}
            </div>
          )}

          <div className="buttons">
            <button
              className="btn-prev"
              onClick={() => {
                props.prev();
                closeTabs();
              }}
              style={{ background: activeColor }}
            >
              BACK STEP
            </button>
            {/* <button onClick={axiosSend}>
sadasdasdasd
            </button> */}
            <button
              id="send"
              className="step9btn"
              style={{ visibility: "hidden" }}
              onClick={axiosSend}
            ></button>
          </div>
        </div>
        <div className="shapes">
          <Elements eleclass="elements" />
          <div className="shapes-form-container-step9">
            {/* ---------------------------------------cartItems[0]--------------------------------------------------- */}
            {cartItems[0] && (
              <div className="shapes-form-step9">
                <div className="detail-line9">
                  <div className="input-line9">
                    <div className="detail9">
                      {/* <img
                        onClick={() => {
                          handleClick();
                          switchActive();
                        }}
                        src={arrow}
                        alt=""
                      /> */}
                      <div
                        className="unitName-9"
                        onClick={() => {
                          handleClick(isShowed, setIsShowed);
                          switchActive();
                        }}
                      >
                        <svg
                          className={cx("step9-svg", isShowed ? "active" : "")}
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                        >
                          <g transform="translate(-825 -522)">
                            <rect
                              className="rect-cards"
                              width="30"
                              height="30"
                              rx="15"
                              transform="translate(825 552) rotate(-90)"
                            />
                            <path
                              className="path-cards"
                              d="M4.152,1.357a1,1,0,0,1,1.7,0l3.2,5.113A1,1,0,0,1,8.2,8H1.8A1,1,0,0,1,.956,6.47Z"
                              transform="translate(845 542) rotate(180)"
                              fill="#fff"
                            />
                          </g>
                        </svg>

                        {unitName[0]}
                      </div>
                      <hr className="card-line"></hr>
                    </div>
                    {isShowed && (
                      <div className="first-tab-container">
                        <div className="first-tab">
                          <Tabs>
                            {checked &&
                              Object.keys(cart[0]["thicknesses"])[0] ===
                                "12mm" && (
                                <Tab
                                  onClick={handleTab}
                                  active={active === 0}
                                  id={0}
                                >
                                  12 mm
                                </Tab>
                              )}
                            {checked2 &&
                              (Object.keys(cart[0]["thicknesses"])[0] ===
                                "20mm" ||
                                Object.keys(cart[0]["thicknesses"])[1] ===
                                  "20mm") && (
                                <Tab
                                  onClick={handleTab}
                                  active={active === 1}
                                  id={1}
                                >
                                  20 mm
                                </Tab>
                              )}
                            {checked7 &&
                              (Object.keys(cart[0]["thicknesses"])[0] ===
                                "20mm" ||
                                Object.keys(cart[0]["thicknesses"])[1] ===
                                  "20mm" ||
                                Object.keys(cart[0]["thicknesses"])[2] ===
                                  "20mm") && (
                                <Tab
                                  onClick={handleTab}
                                  active={active === 2}
                                  id={2}
                                >
                                  30 mm
                                </Tab>
                              )}
                          </Tabs>
                        </div>
                        <>
                          <Content active={active === 0}>
                            <Twelvemm
                              unit={unitName[0]}
                              subCost12={totalPrice12a}
                              img3d12={
                                cart[0] !== undefined && cart[0].kitchen3d_url
                              }
                              data3d12={
                                cart[0] !== undefined && cart[0].kitchen3d_id
                              }
                              true3d12={
                                cart[0] !== undefined && cart[0].kitchen3d
                              }
                            />
                          </Content>
                          <Content active={active === 1}>
                            <Twentymm
                              unit={unitName[0]}
                              subCost20={totalPrice20a}
                              img3d20={
                                cart[0] !== undefined && cart[0].kitchen3d_url
                              }
                              data3d20={
                                cart[0] !== undefined && cart[0].kitchen3d_id
                              }
                              true3d20={
                                cart[0] !== undefined && cart[0].kitchen3d
                              }
                            />
                          </Content>
                          <Content active={active === 2}>
                            <Thirtymm
                              unit={unitName[0]}
                              subCost30={totalPrice30a}
                              img3d30={
                                cart[0] !== undefined && cart[0].kitchen3d_url
                              }
                              data3d30={
                                cart[0] !== undefined && cart[0].kitchen3d_id
                              }
                              true3d30={
                                cart[0] !== undefined && cart[0].kitchen3d
                              }
                            />
                          </Content>
                        </>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {/* ---------------------------------------cartItems[1]--------------------------------------------------- */}
            {cartItems[1] && (
              <div className="shapes-form-step9b">
                <div className="detail-line9">
                  <div className="input-line9">
                    <div className="detail9">
                      <div
                        className="unitName-9"
                        onClick={() => {
                          handleClick(isShowed2, setIsShowed2);
                          switchActive2();
                        }}
                      >
                        <svg
                          className={cx("step9-svg", isShowed2 ? "active" : "")}
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                        >
                          <g transform="translate(-825 -522)">
                            <rect
                              className="rect-cards"
                              width="30"
                              height="30"
                              rx="15"
                              transform="translate(825 552) rotate(-90)"
                            />
                            <path
                              className="path-cards"
                              d="M4.152,1.357a1,1,0,0,1,1.7,0l3.2,5.113A1,1,0,0,1,8.2,8H1.8A1,1,0,0,1,.956,6.47Z"
                              transform="translate(845 542) rotate(180)"
                              fill="#fff"
                            />
                          </g>
                        </svg>
                        {unitName[1]}
                      </div>
                      <hr className="card-line"></hr>
                    </div>
                    {isShowed2 && (
                      <div className="first-tab-container">
                        <div className="first-tab">
                          <Tabs>
                            {checked3 &&
                              Object.keys(cart[1]["thicknesses"])[0] ===
                                "12mm" && (
                                <Tab
                                  onClick={handleTab2}
                                  active={active2 === 0}
                                  id={0}
                                >
                                  12 mm
                                </Tab>
                              )}
                            {checked4 &&
                              (Object.keys(cart[1]["thicknesses"])[0] ===
                                "20mm" ||
                                Object.keys(cart[1]["thicknesses"])[1] ===
                                  "20mm") && (
                                <Tab
                                  onClick={handleTab2}
                                  active={active2 === 1}
                                  id={1}
                                >
                                  20 mm
                                </Tab>
                              )}
                            {checked8 &&
                              (Object.keys(cart[1]["thicknesses"])[0] ===
                                "20mm" ||
                                Object.keys(cart[1]["thicknesses"])[1] ===
                                  "20mm" ||
                                Object.keys(cart[1]["thicknesses"])[2] ===
                                  "20mm") && (
                                <Tab
                                  onClick={handleTab2}
                                  active={active2 === 2}
                                  id={2}
                                >
                                  30 mm
                                </Tab>
                              )}
                          </Tabs>
                        </div>
                        <>
                          <Content active={active2 === 0}>
                            <Twelvemm
                              unit={unitName[1]}
                              subCost12={totalPrice12b}
                              img3d12={
                                cart[1] !== undefined && cart[1].kitchen3d_url
                              }
                              data3d12={
                                cart[1] !== undefined && cart[1].kitchen3d_id
                              }
                              true3d12={
                                cart[1] !== undefined && cart[1].kitchen3d
                              }
                            />
                          </Content>
                          <Content active={active2 === 1}>
                            <Twentymm
                              unit={unitName[1]}
                              subCost20={totalPrice20b}
                              img3d20={
                                cart[1] !== undefined && cart[1].kitchen3d_url
                              }
                              data3d20={
                                cart[1] !== undefined && cart[1].kitchen3d_id
                              }
                              true3d20={
                                cart[1] !== undefined && cart[1].kitchen3d
                              }
                            />
                          </Content>
                          <Content active={active2 === 2}>
                            <Thirtymm
                              unit={unitName[1]}
                              subCost30={totalPrice30b}
                              img3d30={
                                cart[1] !== undefined && cart[1].kitchen3d_url
                              }
                              data3d30={
                                cart[1] !== undefined && cart[1].kitchen3d_id
                              }
                              true3d30={
                                cart[1] !== undefined && cart[1].kitchen3d
                              }
                            />
                          </Content>
                        </>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {/* ---------------------------------------cartItems[2]--------------------------------------------------- */}
            {cart[2] && (
              <div className="shapes-form-step9b">
                <div className="detail-line9">
                  <div className="input-line9">
                    <div className="detail9">
                      <div
                        className="unitName-9"
                        onClick={() => {
                          handleClick(isShowed3, setIsShowed3);
                          switchActive3();
                        }}
                      >
                        <svg
                          className={cx("step9-svg", isShowed3 ? "active" : "")}
                          onClick={() => {
                            handleClick(isShowed3, setIsShowed3);
                            switchActive3();
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                        >
                          <g transform="translate(-825 -522)">
                            <rect
                              className="rect-cards"
                              width="30"
                              height="30"
                              rx="15"
                              transform="translate(825 552) rotate(-90)"
                            />
                            <path
                              className="path-cards"
                              d="M4.152,1.357a1,1,0,0,1,1.7,0l3.2,5.113A1,1,0,0,1,8.2,8H1.8A1,1,0,0,1,.956,6.47Z"
                              transform="translate(845 542) rotate(180)"
                              fill="#fff"
                            />
                          </g>
                        </svg>
                        {unitName[2]}
                      </div>
                      <hr className="card-line"></hr>
                    </div>
                    {isShowed3 && (
                      <div className="first-tab-container">
                        <div className="first-tab">
                          <Tabs>
                            {checked5 &&
                              Object.keys(cart[2]["thicknesses"])[0] ===
                                "12mm" && (
                                <Tab
                                  onClick={handleTab3}
                                  active={active3 === 0}
                                  id={0}
                                >
                                  12 mm
                                </Tab>
                              )}
                            {checked6 &&
                              (Object.keys(cart[2]["thicknesses"])[0] ===
                                "20mm" ||
                                Object.keys(cart[2]["thicknesses"])[1] ===
                                  "20mm") && (
                                <Tab
                                  onClick={handleTab3}
                                  active={active3 === 1}
                                  id={1}
                                >
                                  20 mm
                                </Tab>
                              )}
                            {checked9 &&
                              (Object.keys(cart[2]["thicknesses"])[0] ===
                                "20mm" ||
                                Object.keys(cart[2]["thicknesses"])[1] ===
                                  "20mm" ||
                                Object.keys(cart[2]["thicknesses"])[2] ===
                                  "20mm") && (
                                <Tab
                                  onClick={handleTab3}
                                  active={active3 === 2}
                                  id={2}
                                >
                                  30 mm
                                </Tab>
                              )}
                          </Tabs>
                        </div>
                        <>
                          <Content active={active3 === 0}>
                            <Twelvemm
                              unit={unitName[2]}
                              subCost12={totalPrice12c}
                              img3d12={
                                cart[2] !== undefined && cart[2].kitchen3d_url
                              }
                              data3d12={
                                cart[2] !== undefined && cart[2].kitchen3d_id
                              }
                              true3d12={
                                cart[2] !== undefined && cart[2].kitchen3d
                              }
                            />
                          </Content>
                          <Content active={active3 === 1}>
                            <Twentymm
                              unit={unitName[2]}
                              subCost20={totalPrice20c}
                              img3d20={
                                cart[2] !== undefined && cart[2].kitchen3d_url
                              }
                              data3d20={
                                cart[2] !== undefined && cart[2].kitchen3d_id
                              }
                              true3d20={
                                cart[2] !== undefined && cart[2].kitchen3d
                              }
                            />
                          </Content>
                          <Content active={active3 === 2}>
                            <Thirtymm
                              unit={unitName[2]}
                              subCost30={totalPrice30c}
                              img3d30={
                                cart[2] !== undefined && cart[2].kitchen3d_url
                              }
                              data3d30={
                                cart[2] !== undefined && cart[2].kitchen3d_id
                              }
                              true3d30={
                                cart[2] !== undefined && cart[2].kitchen3d
                              }
                            />
                          </Content>
                        </>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <Modal isShowing={isShowing} hide={toggle} />
          </div>
        </div>
      </div>
    </>
  );
}

export default StepNine;

/*
  const convertToMeters = (unit, value, linear = 0) => {
    // square = 1 lub 0
    let a = 1;
    switch (unit) {
      case 1:
        a = 1000;
        break;
      case 2:
        a = 100;
        break; //return Math.round((resultTotal / 100 * (100 - (square*100)) * 100)) / 100;
      case 3:
        a = 1;
        break; //return Math.round(resultTotal * 100) / 100;
      case 4:
        a = 39.37;
        break; //return Math.round((resultTotal / 1550) * 100) / 100;
      default:
        break;
        
    }
    // console.log(unit, value,a, linear, value / (a * (a - linear * a + linear)) * 100)
    return Math.round(value / (a * (a - linear * a + linear)) * 100) / 100;
  };

  useEffect(() => {
    setResultTotalM(convertToMeters(portion[0].id, resultTotal, 0));
    // if (portion.find((obj) => obj.id === 1)) {
    //   setResultTotalM(Math.round((resultTotal / 1000000) * 100) / 100);
    // } else if (portion.find((obj) => obj.id === 2)) {
    //   setResultTotalM(Math.round((resultTotal / 10000) * 100) / 100);
    // } else if (portion.find((obj) => obj.id === 3)) {
    //   setResultTotalM(Math.round(resultTotal * 100) / 100);
    // } else if (portion.find((obj) => obj.id === 4)) {
    //   setResultTotalM(Math.round((resultTotal / 1550) * 100) / 100);
    // }
   
  }, [portion, resultTotal, setResultTotal, setResultTotalM]);
  
  useEffect(() => {
    setResSum(convertToMeters(portion[0].id, result,1));
    // if (portion.find((obj) => obj.id === 1)) {
    //   setResSum(Math.round((result / 1000) * 100) / 100);
    // } else if (portion.find((obj) => obj.id === 2)) {
    //   setResSum(Math.round((result / 100) * 100) / 100);
    // } else if (portion.find((obj) => obj.id === 3)) {
    //   setResSum(Math.round(result * 100) / 100);
    // } else if (portion.find((obj) => obj.id === 4)) {
    //   setResSum(Math.round((result / 39.4) * 100) / 100);
    // }
    
  }, [portion, result, setResSum]);

  */
